

























import { Component, Vue, Mixins, Prop, Watch } from 'vue-property-decorator';
import ProgressBar from '@/components/ProgressBar.vue';

enum State {
    Offline,
    Connecting,
    JustConnected,
    Connected,
}

@Component({
    components: {
        ProgressBar,
    },
})
export default class TopMenu extends Vue {
    public isMenuOpened: boolean = false;

    @Prop()
    public menuIcon!: string;

    @Prop()
    public loading!: boolean;

    @Prop({required: false, default: false})
    public offline!: boolean;

    public state: State = State.Connected;

    public get menuIconClass() {
        const result: {[name: string]: boolean} = {};
        result[this.menuIcon] = true;
        return result;
    }

    private timeoutRef: number;

    public mounted() {
        if (this.offline) {
            this.state = State.Connecting;
            this.timeoutRef = setTimeout(this.updateState, 10000);
        } else {
            this.state = State.Connected;
        }
    }

    @Watch('offline')
    private offlineChanged() {
        clearTimeout(this.timeoutRef);
        if (this.offline && this.state !== State.Offline) {
            this.state = State.Connecting;
            this.timeoutRef = setTimeout(this.updateState, 10000);
        } else if (!this.offline && this.state !== State.Connected) {
            this.state = State.JustConnected;
            this.timeoutRef = setTimeout(this.updateState, 3000);
        }
    }

    private updateState() {
        switch (this.state) {
            case State.JustConnected:
                this.state = State.Connected;
                break;
            case State.Connecting:
                this.state = State.Offline;
                break;
        }
    }
}
